export default "__VITE_ASSET__2ICMYGLA__"